module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_c('div', {
    staticClass: "AccomodationsFilter"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('span', [_vm._v(_vm._s( /* This is just an empty flex item that makes the spacing look good! */ ))]), _vm._v(" "), _c('div', {
    class: {
      field: true, date: true, disabled: (_vm.$store.state.cart.addToOrder && _vm.$store.state.cart.addToOrder.number)
    }
  }, [_c('div', {
    staticClass: "label-wrapper"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Välj datum")]), _vm._v(" "), _c('Dropdown', {
    ref: "dateDropdown",
    attrs: {
      "prefixicon": "calendar",
      "prefixicon-validated": "calendar-white",
      "tabindex": "0",
      "options": [],
      "label": _vm.$store.state.accomodationsFilter.date.startDate ? (
        _vm.moment(_vm.$store.state.accomodationsFilter.date.startDate).format('D[/]M') +
        ' - ' +
        _vm.moment(_vm.$store.state.accomodationsFilter.date.endDate).format('D[/]M')
      ) : 'När som helst',
      "bold-label": false,
      "validated": _vm.$store.state.accomodationsFilter.date.startDate
    },
    on: {
      "clicked": _vm.openDatePicker,
      "clicked-suffix": _vm.dateClear
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field field-beds"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Antal bäddar")]), _vm._v(" "), _c('CounterButton', {
    attrs: {
      "label": "Antal bäddar",
      "count": _vm.$store.state.accomodationsFilter.beds
    },
    on: {
      "changedCount": function($event) {
        _vm.awaitFilter({
          waitForUser: true,
          callback: function() {
            _vm.changeBeds($event);
          }
        });
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field field-bedrooms"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Antal sovrum")]), _vm._v(" "), _c('CounterButton', {
    attrs: {
      "label": "Antal sovrum",
      "count": _vm.$store.state.accomodationsFilter.bedrooms
    },
    on: {
      "changedCount": function($event) {
        _vm.awaitFilter({
          waitForUser: true,
          callback: function() {
            _vm.changeRooms($event);
          }
        });
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field field-filter-button"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('OutlineButton', {
    staticClass: "filter-bt",
    class: {
      active: _vm.filtersToggle
    },
    attrs: {
      "label": "Fler filter",
      "closeLabel": "Stäng filter",
      "icon": "Filter",
      "iconscale": 1.5,
      "status": _vm.filtersToggle
    },
    on: {
      "clicked": _vm.toggleFilters
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "hide-on-mobile"
  }, [_vm._v(_vm._s( /* This is just an empty flex item that makes the spacing look good! */ ))])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [_c('AccomodationsFilterSub', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtersToggle),
      expression: "filtersToggle"
    }]
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4180c938"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/Accomodation/List/Filter/AccomodationsFilter.vue
// module id = 957
// module chunks = 0